<template>
  <!--调用员工档案的用户-->
  <el-select class="td_select"
             v-model="values"
             :loading="loading"
             clearable
             filterable>
    <el-option
      class="td_option"
      v-for="(item, index) in options"
      :key="index"
      :label="item.username"
      :value="item.username"
      @click.native="handleSelect(item)">
<!--        <el-avatar size="small" :src="item.avatar === null? item.avatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>-->
      <el-avatar size="small" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
        <div style="padding: 2.5px;line-height: 20px;">
          {{item.username}}
          <el-row>
            <el-col :span="12">
              <span>{{item.name}}</span>
            </el-col>
            <el-col :span="12">
              <span>{{item.phone}}</span>
            </el-col>
          </el-row>
        </div>
    </el-option>
  </el-select>
</template>
<script>
import { fetchUserId } from '@/api/tms/tmsemployee'

export default {
  name: 'd2-container-employee',
  data () {
    return {
      values: this.value,
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    remoteMethod () {
      this.loading = true
      fetchUserId().then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.$emit('change', val)
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val.toString())
    },
    value: function (val, oldVal) {
      this.values = val
    }
  },
  mounted () {
    this.remoteMethod()
  }
}
</script>

<style lang="scss" scoped>
  .td_option {
    height: 50px;
    display: flex;
    align-items: center;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-employee/index.vue"
}
</vue-filename-injector>
